document.addEventListener('DOMContentLoaded', function(){
  var card = document.getElementById('flipCard');
  var inner = document.getElementById('flipInner');
  if(!card || !inner) return;
  var flipped = false;
  var autoFlip = setInterval(doFlip, 4000);
  function doFlip(){ flipped = !flipped; inner.classList.toggle('flipped', flipped); }
  card.addEventListener('click', function(){
    clearInterval(autoFlip);
    doFlip();
    autoFlip = setInterval(doFlip, 4000);
  });
  card.addEventListener('mousemove', function(e){
    var rect = card.getBoundingClientRect();
    var dx = (e.clientX - (rect.left+rect.width/2))/(rect.width/2);
    var dy = (e.clientY - (rect.top+rect.height/2))/(rect.height/2);
    inner.style.transform = (flipped?'rotateY(180deg) ':'')+'rotateY('+(dx*12)+'deg) rotateX('+(-dy*8)+'deg)';
    inner.style.transition = 'transform 0.1s ease';
  });
  card.addEventListener('mouseenter', function(){ inner.style.animation='none'; });
  card.addEventListener('mouseleave', function(){
    inner.style.transition='transform 0.9s cubic-bezier(0.4,0,0.2,1)';
    inner.style.transform = flipped?'rotateY(180deg)':'';
    setTimeout(function(){ if(!flipped) inner.style.animation='cardFloat 5s ease-in-out infinite'; },900);
  });
});
